import React from "react";
import "./researchTemplate.scss";
import RightArrow2 from "SVG/RightArrow2.svg";
import ResearchCard from "../../molecules/researchCard/researchCard";
import PageTitle from "componets/molecules/PageTitle/pageTitle";
import PersonalFooter from "componets/organisms/personalFooter/personalFooter";
import ResearchText from "componets/atoms/researchText/researchText";
import SemiCircleCard from "componets/molecules/circleCard/semiCircleCard";

const ResearchTemplate = ({ contentData }) => {
  const pageData = contentData[0];
  const seedbeds = contentData[1].slice(0, 3);
  const labs = contentData[2].slice(0, 3);
  const breadcrumsData = [
    { text: "Inicio", link: "/" },
    { text: "Investigación", link: "/investigacion" },
  ];
  return (
    <div className="research-template__main-container">
      <>
        {!contentData ? (
          <p>Un momento, mientras la información se carga</p>
        ) : (
          <>
            <PageTitle
              breadData={breadcrumsData}
              type="left"
              imgSrc={pageData.imgURL}
              data={{
                title: pageData.header.titulo,
                subtitle: pageData.header.subtitulo,
                description: pageData.header.descripcion,
              }}
            />

            <div className="research-template__buttons-section">
              <div className="research-template__SemiCircleCard">
                <SemiCircleCard
                  type="oval"
                  textSize={2}
                  data={{
                    title: pageData.boton1.titulo,
                    description: pageData.boton1.descripcion,
                    link: "/" + pageData.boton1.url,
                  }}
                />
              </div>
              <div className="research-template__SemiCircleCard">
                <SemiCircleCard
                  type="oval"
                  textSize={2}
                  data={{
                    title: pageData.boton2.titulo,
                    description: pageData.boton2.descripcion,
                    link: "/" + pageData.boton2.url,
                  }}
                />
              </div>
            </div>

            <ResearchText
              title={pageData.laboratoriesSection.titulo}
              text={pageData.laboratoriesSection.descripcion}
            />

            <div className="research-template__card-section">
              {labs.map((labCard, index) => (
                <div key={index} className="research-template__card">
                  <ResearchCard
                    image={labCard.imgURL}
                    title={labCard.titulo}
                    subtitle={labCard.type}
                    color={labCard.color}
                    url={labCard.url}
                  />
                </div>
              ))}
              <div className="research-template__arrow">
                <a href={pageData.laboratoriesSection.boton.enlace}>
                  <img
                    src={RightArrow2}
                    alt=""
                    className="research-template__arrow-image"
                  />
                </a>
              </div>
            </div>

            <a
              className="research-template__button"
              href={pageData.laboratoriesSection.boton.enlace}
              style={{ backgroundColor: "#7D2D00" }}
            >
              <p className="research-template__button-text">
                {pageData.laboratoriesSection.boton.textoBoton}
              </p>
            </a>

            <ResearchText
              title={pageData.seedbedsSection.titulo}
              text={pageData.seedbedsSection.descripcion}
            />

            <div className="research-template__card-section">
              {seedbeds.map((seedbedCard, index) => (
                <div key={index} className="research-template__card">
                  <ResearchCard
                    image={seedbedCard.imgURL}
                    title={seedbedCard.titulo}
                    subtitle={seedbedCard.type}
                    color={seedbedCard.color}
                    url={seedbedCard.url}
                  />
                </div>
              ))}
              <div className="research-template__arrow">
                <a href={pageData.seedbedsSection.boton.enlace}>
                  <img
                    src={RightArrow2}
                    alt=""
                    className="research-template__arrow-image"
                  />
                </a>
              </div>
            </div>

            <a
              className="research-template__button"
              href={pageData.seedbedsSection.boton.enlace}
              style={{ backgroundColor: "#B86800" }}
            >
              <p className="research-template__button-text">
                {pageData.seedbedsSection.boton.textoBoton}
              </p>
            </a>

            <PersonalFooter textSize={1} />
          </>
        )}
      </>
    </div>
  );
};

export default ResearchTemplate;
